import React from "react";
import Navbar from "../landingpage/Navbar";
import ResponsiveNavbar from "../landingpage/ResponsiveNavbar";

function SeoMarketingShell({ children }) {
  return (
    <div className="w-full min-h-screen overflow-x-hidden bg-[#F9FAFB] font-segoe">
      <Navbar useHomeHashLinks />
      <ResponsiveNavbar useHomeHashLinks />
      {children}
    </div>
  );
}

export default SeoMarketingShell;
